module.exports = __webpack_public_path__ + "static/media/5.4956a140.jpg";